const BackIcon = () => {
  return (
    <svg viewBox="0 0 9.82 18">
      <g transform="translate(-141.882 -63.035)">
        <path d="M142.7,63.035a.815.815,0,0,0-.572,1.4l7.6,7.6-7.6,7.6a.817.817,0,1,0,1.156,1.156l8.174-8.174a.817.817,0,0,0,0-1.156l-8.174-8.174A.806.806,0,0,0,142.7,63.035Z" />
      </g>
    </svg>
  );
};

export default BackIcon;
